import React, { useMemo } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import convertAccounts from 'packages/ui/Arborist/utils'
import NestedAccount from './NestedAccount'

import {
  AccountCard,
  CountBadge,
  ScrollableAccountsContainer
} from './styles/accounts.styles'

const AccountsSection = ({ accounts }) => {
  const { t } = useTranslation()

  const convertedAccounts = useMemo(() => {
    return convertAccounts({ accounts: accounts.children })
  }, [accounts])

  const getTotalLeafNodesCount = (account) => {
    if (!account.children) return 0
    let totalSites = 0
    const countNestedSites = (children) => {
      children?.forEach(child => {
        if (!child.children.length) {
          totalSites++
        } else {
          countNestedSites(child.children)
        }
      })
    }
    countNestedSites(account.children)
    return totalSites
  }

  const shouldExpandByDefault = (account) => {
    if (account.children?.length === 1) {
      const onlyChild = account.children[0]
      return onlyChild.children?.length >= 1 ? true : onlyChild.children?.length === 0
    }
    return false
  }

  const totalLeafNodes = useMemo(() => {
    return convertedAccounts.reduce((total, account) => total + getTotalLeafNodesCount(account), 0)
  }, [convertedAccounts])

  return (
    <AccountCard>
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            {t('profile.accounts_sites')}
          </Typography>
          <CountBadge>
            {totalLeafNodes}
          </CountBadge>
        </Stack>

        <Box sx={{ borderBottom: '1px solid #F6F7F8' }} />

        <ScrollableAccountsContainer>
          <Stack spacing={1}>
            {convertedAccounts.map(account => (
              <NestedAccount
                key={account.id}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                account={account}
                getTotalLeafNodesCount={getTotalLeafNodesCount}
                shouldExpandByDefault={shouldExpandByDefault}
              />
            ))}
          </Stack>
        </ScrollableAccountsContainer>
      </Stack>
    </AccountCard>
  )
}

export default AccountsSection
